
import React from 'react';
import { Route } from 'react-router-dom';

// Auth Pages
import Login from '@/pages/Login';
import Register from '@/pages/Register';

// Common Pages
import NotFound from '@/pages/NotFound';
import Index from '@/pages/Index';
import Documentation from '@/pages/Documentation';

const CommonRoutes = () => {
  return [
    <Route key="index" path="/" element={<Index />} />,
    <Route key="login" path="/login" element={<Login />} />,
    <Route key="register" path="/register" element={<Register />} />,
    <Route key="documentation" path="/documentation" element={<Documentation />} />,
    <Route key="notfound" path="*" element={<NotFound />} />
  ];
};

export default CommonRoutes;
